import { graphql } from "@/lib/gql/__generated__";

export const HotelTemplateSettingsResetMutation = graphql(/* GraphQL */ `
	mutation HotelTemplateSettingsReset($input: HotelTemplateSettingsResetInput!) {
		hotelTemplateSettingsReset(input: $input) {
			userErrors
			hotelTemplateSettings {
				id
				hotelID
				hotelTemplateType
				hotelTemplateTypeSelectable
			}
		}
	}
`);
